export default "__VITE_ASSET__DIcobbS4__"